export default "__VITE_PUBLIC_ASSET__af4129e2__"